import React from 'react'
import ReactDOM from 'react-dom/client'
import { HeroUIProvider } from "@heroui/react"
import { ThemeProvider } from "./providers/theme-provider"
import App from './App'
import './index.css'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { useLanguageStore } from './stores/language-store'
import { ErrorBoundary } from './components/ErrorBoundary'

import DevClickToComponent from './components/utils/dev-click-to-component';
import './dev-error-handlers';

if (import.meta.env.DEV) {
  console.log('🔧 Running in DEVELOPMENT mode');
  console.log('📦 React version:', React.version);
  console.log('🌐 API Base URL:', import.meta.env.VITE_API_BASE_URL || '/api');
}

// Root Component با RTL Support
function Root() {
  const language = useLanguageStore((state) => state.language);

  // HeroUI locale mapping
  const locale = React.useMemo(() => {
    switch (language) {
      case 'fa':
        return 'fa-IR';
      case 'ar':
        return 'ar-SA';
      case 'en':
      default:
        return 'en-US';
    }
  }, [language]);

  return (
    <React.StrictMode>
      <ErrorBoundary>
        <HeroUIProvider locale={locale}>
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
            <I18nextProvider i18n={i18n}>
              {import.meta.env.DEV && <DevClickToComponent />}
              <App />
            </I18nextProvider>
          </ThemeProvider>
        </HeroUIProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
